<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12 pb-3>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							required
							v-model="$v.model.name.$model"
							:error="$v.model.name.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-textarea
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Descripción"
							no-resize
							required
							v-model="$v.model.description.$model"
							:error="$v.model.description.$error"
						>
						</v-textarea>
					</v-flex>
					<v-flex xs12 pb-3>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Código"
							required
							:disabled="codeProjectDisabled"
							:readonly="codeProjectDisabled"
							v-model="$v.model.codeProject.$model"
							:error="$v.model.codeProject.$error"
						>
						</v-text-field>
					</v-flex>
					<v-layout row pl-2>
						<v-flex
							xs3
							v-for="(value, key) in languages"
							:key="key"
						>
							<v-checkbox
								color="primary"
								:label="key"
								v-model="value.isSelected"
							>
							</v-checkbox>
						</v-flex>
					</v-layout>
					<v-flex xs12>
						<v-checkbox
								color="primary"
								label="Restringir accesos web services"
								v-model="model.flagAllowAccess"
							>
						</v-checkbox>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="disabled"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const PAGE_PROJECT_LIST = 'page-project';

function data() {
	return {
		countries: [],
		loading: false,
		model: {
			codeProject: '',
			description: '',
			name: '',
		},
	};
}

async function created() {
	if (this.mode === 'edit') {
		const { data: record } = await this.$http.get(`project/${this.projectId}`);
		if (record.data) {
			this.model = {
				name: record.data.name,
				codeProject: record.data.codeProject,
				description: record.data.description,
				flagAllowAccess: record.data.flagAllowAccess || false,
			};
			this.languages = record.data.languages;
		}
	}
}

function closeModal() {
	this.goTo(PAGE_PROJECT_LIST);
}

function codeProjectDisabled() {
	return !!this.projectId && !!this.$v.model.codeProject.$model;
}

function mode() {
	return this.projectId ? 'edit' : 'create';
}

async function submitForm() {
	const body = {
		name: this.model.name,
		codeProject: this.model.codeProject,
		description: this.model.description,
		languages: this.languages,
		flagAllowAccess: Number(this.model.flagAllowAccess),
	};
	const method = this.mode === 'create' ? 'post' : 'put';
	const url = this.mode === 'create' ? 'project' : `project/${this.projectId}`;
	const message = this.mode === 'create' ? 'creado' : 'editado';
	this.loading = true;
	try {
		await this.$http[method](url, body);
		this.showNotification(`Proyecto ${message} correctamente.`);
		this.goTo(PAGE_PROJECT_LIST);
	} catch (err) {
		if (err.status === 500) {
			this.showError();
		}
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
			codeProject: {
				required,
			},
			description: {
				required,
			},
		},
	};
	return validation;
}
function disabled() {
	let disabledButton = true;
	const languagesKeys = Object.keys(this.languages);
	languagesKeys.forEach((key) => {
		if (this.languages[key].isSelected && !this.$v.$invalid) {
			disabledButton = false;
		}
	});
	return disabledButton || this.loading;
}

export default {
	name: 'projects-form',
	created,
	computed: {
		codeProjectDisabled,
		mode,
		disabled,
	},
	data,
	methods: {
		closeModal,
		submitForm,
	},
	props: {
		projectId: {
			type: [Number, String],
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/projects/project-form.vue